import { render, staticRenderFns } from "./companySettingsDialog.vue?vue&type=template&id=198708db&scoped=true"
import script from "./companySettingsDialog.vue?vue&type=script&lang=js"
export * from "./companySettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./companySettingsDialog.vue?vue&type=style&index=0&id=198708db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198708db",
  null
  
)

export default component.exports